/* 🤖 this file was generated by svg-to-ts */
export const waytrArrowDown = {
    name: 'arrow_down',
    data: `<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.1 48.1"><path d="M2.95,10.6c-.74,0-1.49,.29-2.06,.85C-.23,12.58-.23,14.44,.89,15.57l21.08,21.08c.54,.54,1.31,.85,2.06,.85s1.48-.27,2.06-.85L47.15,15.59c1.18-1.11,1.19-3.02,.07-4.14s-2.99-1.13-4.12,0h0S24.07,30.51,24.07,30.51L5.01,11.45c-.56-.56-1.32-.85-2.06-.85h0Z"/></svg>`,
};
